import { render, staticRenderFns } from "./EmployeeDetails.component.vue?vue&type=template&id=3869739e&"
import script from "./EmployeeDetails.component.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetails.component.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeDetails.component.vue?vue&type=style&index=0&id=3869739e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports